/**************************************************
 * Nombre:       Formulario_Varietal_Descripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {HowToRegOutlined, PersonOutline} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";

const Formulario_Varietal_Descripcion = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={PersonOutline} nombre={'Caficultor'} dato={'caficultor'} {...props}


                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={HowToRegOutlined} nombre={'Persona de Procesos'} dato={'procesos'} {...props}


                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Descripcion'} dato={'descripcion'} {...props}
                                  requerido={'La descripcion es requerida'}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Perfil sensorial'} dato={'perfil'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Proceso de beneficio'} dato={'proceso'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Varietal_Descripcion